import { Component, inject, input } from '@angular/core';
import { RegionItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'wr-region-dashboard-info',
  templateUrl: './region-dashboard-info.component.html',
  styleUrls: ['./region-dashboard-info.component.scss'],
})
export class RegionDashboardInfoComponent {

  readonly region = input<RegionItemDto | undefined>();
  readonly router = inject(Router);

  editRegion(region: RegionItemDto) {
    this.router.navigate(['region', region.id]);
  }

}
